import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pagination, Empty } from "antd";
import { Link } from "react-router-dom";
import Lottie from "react-lottie-player";

import { MeetingAction } from "../../store/actions";

import { meeting, Loader, Buttons, Spacer } from "../../components";

import { Images } from "../../config";

function UpcomingMeetings() {
  const dispatch = useDispatch();

  const {
    upcomingMeetings,
    pastMeetings,
    upcomingMeetingsCount,
    pastMeetingsCount,
    isUpcomingMeetingsLoading,
  } = useSelector((state) => state.meeting);

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [pageNo, setPageNo] = useState(1);

  useEffect(() => {
    fetchMeeting();
  }, [pageNo]);

  const fetchMeeting = () => {
    dispatch(MeetingAction.getUpcomingMeetings({}));
    dispatch(MeetingAction.getAllMeetingsAndCount());
  };

  const handlePagination = (pagenumber) => {
    setOffset((pagenumber - 1) * limit);
    setPageNo(pagenumber);
  };

  return (
    <div className="text-black h-[18.25em] overflow-auto">
      {isUpcomingMeetingsLoading ? (
        <Loader.Circular />
      ) : upcomingMeetingsCount === 0 && pastMeetingsCount === 0 ? (
        <div className="flex flex-col justify-center items-center w-full">
          <Lottie
            loop
            animationData={Images.CreateMeeting}
            play
            style={{ width: "12.25em" }}
          ></Lottie>
          <Link to="/meetings/add-meeting">
            <Buttons.DefaultButton size="medium">
              Create New Meeting
            </Buttons.DefaultButton>
          </Link>
        </div>
      ) : (
        <div>
          {upcomingMeetingsCount > 0 && (
            <div>
              <div className="box-title">
                Upcoming Meetings ({upcomingMeetingsCount})
              </div>
              <Spacer height={10} />
              {upcomingMeetings?.map((item, index) => (
                <meeting.MeetingRow item={item} index={index} key={index} />
              ))}
            </div>
          )}
          {upcomingMeetingsCount < 2 && pastMeetingsCount > 0 && (
            <div>
              <div className="box-title">
                Past Meetings ({pastMeetingsCount})
              </div>
              <Spacer height={10} />
              {pastMeetings?.map((item, index) => (
                <meeting.MeetingRow
                  item={item}
                  index={index}
                  key={index}
                  meetingtype="past"
                />
              ))}
            </div>
          )}
          {/* <div className="flex justify-center items-center p-3">
                  <Pagination
                    responsive="true"
                    showSizeChanger={false}
                    hideOnSinglePage={false}
                    current={pageNo}
                    pageSize={limit}
                    total={upcomingMeetingsCount}
                    onChange={handlePagination}
                  />
                </div> */}
        </div>
      )}
    </div>
  );
}
export default UpcomingMeetings;
